export default {
  airtableEnv: 'Live',
  company: 'focus',
  project: 'demo',
  env: 'live',
  apiUrl: 'https://us-central1-learn-67acf.cloudfunctions.net'
};
